import { render, staticRenderFns } from "./DownloadPedido.vue?vue&type=template&id=57af7009&"
import script from "./DownloadPedido.vue?vue&type=script&lang=js&"
export * from "./DownloadPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports